
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import Map from "@/components/Map.vue";
import Utils from "./Utils";
import store from "@/store/index";
import isMobile from "ismobilejs";

export default defineComponent({
  components: {
    Map,
  },
  props: {
    isMap: {
      type: Boolean,
    },
    isGlobalMenu: {
      type: Boolean,
    },
    demo: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    campaign() {
      return store.state.campaign;
    },
  },
  watch: {
    isGlobalMenu(value) {
      if (value) {
        this.isMenuOpen = false;
      }
    },

    campaign(value) {
      this.campaignList = value;

      if (this.campaignList) {
        this.isCampaignApplied =
          this.campaignList.findIndex((v) => v.canApply && !v.isApply) === -1;
      }
    },
  },
  setup(props, context) {
    const isMapOpen = ref<boolean>(false);
    const toggleMap = () => {
      isMapOpen.value = !isMapOpen.value;
    };
    const mobile =
      isMobile(window.navigator).phone || isMobile(window.navigator).tablet;

    const birdView = ref<boolean>(false);
    if (mobile) birdView.value = true;
    const toggleBirdView = () => {
      const unityInstance = store.state.unityInstance;
      birdView.value = !birdView.value;
      unityInstance.SendMessage(
        "[GameManager]",
        "SwitchBirdView",
        birdView.value ? 1 : 0
      );
    };

    const isMenuOpen = ref<boolean>(false);
    const toggleMenu = () => {
      isMenuOpen.value = !isMenuOpen.value;
    };

    const openMenu = () => {
      isMenuOpen.value = true;
    };

    const closeMenu = () => {
      isMenuOpen.value = false;
    };

    const closeMenuAndOpenMap = () => {
      isMenuOpen.value = false;
      isMapOpen.value = true;
    };

    const router = useRouter();
    const link = (path: string) => {
      router.push(path);
      isMenuOpen.value = false;
    };

    const isDialog = ref<boolean>(false);
    const closeMenuAndOpenDialog = () => {
      isMenuOpen.value = false;
      isDialog.value = true;
    };
    const logout = async () => {
      await Utils.logout();
      location.href = "/virtual/login/";
    };

    const name = ref<string>("こんにちは！");
    onMounted(async () => {
      name.value = (await Utils.getName()) + "さん！";
      resize();

      document.addEventListener("visibilitychange", () => {
        if (!bgm.value || !audio.value) return;
        if (document.visibilityState === "visible") {
          if (bgm.value.classList.contains("on")) audio.value.play();
        } else {
          audio.value.pause();
        }
      });

      window.addEventListener("keydown", (event: KeyboardEvent) => {
        switch (event.code) {
          case "Enter":
          case "ArrowUp":
          case "ArrowDown":
          case "ArrowLeft":
          case "ArrowRight":
          case "KeyA":
          case "KeyS":
          case "KeyD":
          case "KeyW":
            if (isPointDescOpen.value) isPointDescOpen.value = false;
            break;
        }
      });
    });

    const menuList = ref<HTMLElement>();
    const resize = () => {
      if (!menuList.value) return;
      menuList.value.style.maxHeight = Utils.contentHeight("px");
    };

    const isPointDescOpen = ref<boolean>(false);
    const pointDesc = ref<HTMLElement>();
    const togglePointDesc = () => {
      isPointDescOpen.value = !isPointDescOpen.value;
      // if (pointDesc.value) pointDesc.value.classList.toggle("show");
    };

    const se = ref<HTMLAudioElement>();
    const bgm = ref<HTMLElement>();
    const audio = ref<HTMLAudioElement>();

    const toggleBgm = () => {
      if (!bgm.value || !audio.value) return;
      bgm.value.classList.toggle("on");
      const isOn = bgm.value.classList.contains("on");
      if (isOn) {
        audio.value.volume = 0.5;
        audio.value.play();
      } else {
        audio.value.pause();
      }

      const unityInstance = store.state.unityInstance;
      unityInstance.SendMessage("[GameManager]", "SoundOnOff", isOn ? 1 : 0);

      context.emit("toggleSound", isOn);
    };

    const openPresent = () => {
      const isOn = bgm.value ? bgm.value.classList.contains("on") : false;
      if (isOn && se.value) se.value.play();
      setTimeout(() => {
        location.href = `${location.origin}/virtual/present/`;
        // window.open(`${location.origin}/virtual/present/`, "ichijo");
      }, 300);
    };

    const isCampaignWindow = ref<boolean>(false);
    const campaignList = ref<Array<Campaign>>([]);
    const isCampaignApplied = ref<boolean>(false);

    const selectCampaign = (campaign: Campaign) => {
      isCampaignWindow.value = false;
      if (!campaign.canApply || campaign.isApply) return;

      store.commit("setSelectCampaign", campaign);
    };

    const resetCampaign = async () => {
      await fetch(
        `${location.origin}/virtual/app/resetCampaign.php?mode=table`
      );
    };

    return {
      isMapOpen,
      isMenuOpen,
      isDialog,
      toggleMap,
      toggleBirdView,
      toggleMenu,
      openMenu,
      closeMenu,
      closeMenuAndOpenMap,
      openPresent,
      link,
      closeMenuAndOpenDialog,
      logout,
      name,
      menuList,
      resize,
      pointDesc,
      isPointDescOpen,
      togglePointDesc,
      bgm,
      audio,
      toggleBgm,
      birdView,
      se,
      isCampaignWindow,
      campaignList,
      isCampaignApplied,
      selectCampaign,
      resetCampaign,
    };
  },
});
